// extracted by mini-css-extract-plugin
export default {"status":"Status_status__PHQ5v","status_box":"Status_status_box__9QlGC","button":"Status_button__a4N5n","button_dark":"Status_button_dark__or9C1"};